<template>
  <div class="mentions-legales-page">
    <!-- En-tête avec dégradé -->
    <header class="header">
      <div class="header-content">
        <h1 class="main-title">Politique de confidentialité et conditions d'utilisation</h1>
        <p class="subtitle">Dernière mise à jour : 1 janvier 2025</p>
      </div>
    </header>

    <div class="content-container">
      <!-- Section Contact -->
      <section class="card contact-card">
        <div class="card-content">
          <h2 class="section-title">Contact</h2>
          <div class="text-content">
            <p>
              Pour toute question ou préoccupation concernant notre politique de confidentialité ou nos 
              conditions d'utilisation, veuillez nous contacter :
            </p>
            <p class="contact-email">
              <strong>Email :</strong> <router-link to="/contact" class="link">via notre formulaire</router-link>
            </p>
            <p class="contact-email">
              <strong>Téléphone :</strong> <img src="/img/phone-number.png" alt="Numéro de téléphone Arynae" class="phone-img" />
            </p>
          </div>
          <p> ou à l'adresse suivante :</p>
          <div class="contact-logo">
            <img src="/img/mentions-legales.jpg" alt="Politique de confidentialité" class="logo-img" />
          </div>
        </div>
      </section>

      <!-- Politique de confidentialité -->
      <section class="card policy-card">
        <div class="card-content">
          <h2 class="section-title">Politique de confidentialité</h2>
          
          <h3 class="subsection-title">1. Collecte de données</h3>
          <div class="text-content">
            <p>
              Nous collectons différents types d'informations pour fournir et améliorer notre service :
            </p>
            <ul class="feature-list">
              <li><strong>Informations personnelles :</strong> Nom, adresse email, numéro de téléphone, informations de paiement.</li>
              <li><strong>Données d'utilisation :</strong> Informations sur la façon dont vous accédez et utilisez notre service.</li>
              <li><strong>Cookies et technologies de suivi :</strong> Utilisation de cookies et technologies similaires pour suivre l'activité sur notre service.</li>
            </ul>
          </div>

          <h3 class="subsection-title">2. Utilisation des données</h3>
          <div class="text-content">
            <p>
              Nous utilisons les données collectées à diverses fins :
            </p>
            <ul class="feature-list">
              <li><strong>Fourniture de service :</strong> Pour fournir, maintenir et améliorer notre service.</li>
              <li><strong>Communications :</strong> Pour vous envoyer des notifications importantes, mises à jour et informations pertinentes.</li>
              <li><strong>Communications SMS :</strong> Pour vous envoyer des notifications de service, des mises à jour ou des informations demandées par SMS. La fréquence des messages varie. Des frais de message et de données peuvent s'appliquer. Répondez STOP pour vous désabonner à tout moment.</li>
              <li><strong>Marketing :</strong> Pour vous informer de nos offres, services et promotions.</li>
            </ul>
          </div>

          <h3 class="subsection-title">3. Partage de données</h3>
          <div class="text-content">
            <p>
              Vos informations peuvent être partagées avec :
            </p>
            <ul class="feature-list">
              <li><strong>Prestataires de services :</strong> Tiers qui nous aident à fournir et améliorer notre service.</li>
              <li><strong>Exigences légales :</strong> Pour se conformer aux lois ou répondre aux demandes gouvernementales légitimes.</li>
            </ul>
            <p>
              <strong>Exclusion des données SMS :</strong> Nonobstant ce qui précède, les informations mobiles et les données d'opt-in SMS ne seront pas partagées avec des tiers ou des affiliés à des fins de marketing ou promotionnel. Toutes les catégories ci-dessus excluent les données de consentement et d'opt-in de messagerie textuelle ; ces informations ne seront partagées avec aucun tiers.
            </p>
          </div>

          <h3 class="subsection-title">4. Protection des données</h3>
          <div class="text-content">
            <p>
              Nous mettons en œuvre des mesures de sécurité pour protéger vos informations :
            </p>
            <ul class="feature-list">
              <li><strong>Chiffrement :</strong> Utilisation de protocoles de sécurité comme SSL pour protéger les données en transit.</li>
              <li><strong>Accès restreint :</strong> Accès limité aux informations personnelles pour les employés autorisés et les partenaires de service.</li>
            </ul>
          </div>

          <h3 class="subsection-title">5. Droits des utilisateurs</h3>
          <div class="text-content">
            <p>
              Vous avez des droits concernant vos informations personnelles :
            </p>
            <ul class="feature-list">
              <li><strong>Accès :</strong> Vous pouvez demander une copie des informations que nous détenons à votre sujet.</li>
              <li><strong>Correction :</strong> Vous pouvez demander la correction de toute information incorrecte.</li>
              <li><strong>Suppression :</strong> Vous pouvez demander la suppression de vos informations personnelles.</li>
            </ul>
            <p>
              Pour exercer ces droits, veuillez nous contacter à l'adresse indiquée ci-dessous ou 
              <router-link to="/contact" class="link">via notre formulaire</router-link>.
            </p>
          </div>

          <h3 class="subsection-title">6. Cookies et technologies de suivi</h3>
          <div class="text-content">
            <p>Nous utilisons des cookies, des balises Web et des technologies similaires pour collecter les données suivantes liées à l'utilisation et à l'appareil lorsque vous accédez à notre site Web et utilisez nos services :</p>
            <ul class="feature-list">
              <li>Pages Web visitées, heure d'accès, fréquence et durée des visites, liens cliqués, interaction avec les publicités.</li>
              <li>Segment ou catégorie d'utilisateurs.</li>
              <li>Adresse IP, modèle ou type d'appareil, système d'exploitation et version, type de navigateur et paramètres.</li>
              <li>Identifiants (identifiant de l'appareil, identifiant de publicité, jeton d'appareil individuel).</li>
              <li>Données relatives aux cookies (par exemple, identifiant de cookie).</li>
            </ul>
          </div>

          <h3 class="subsection-title">7. Services tiers</h3>
          <div class="text-content">
            <p>Nous utilisons Stripe pour les paiements, les analyses et d'autres services commerciaux. Stripe collecte et traite des données personnelles, y compris des informations d'identification sur les appareils qui se connectent à ses services via des cookies et des technologies similaires. Stripe utilise ces informations pour exploiter et améliorer les services qu'elle nous fournit, notamment pour la détection des fraudes, la prévention des pertes, l'authentification et les analyses. Vous pouvez en savoir plus sur Stripe et ses activités de traitement via leur politique de confidentialité à l'adresse <a href="https://stripe.com/privacy" class="link">https://stripe.com/privacy</a>.</p>
          </div>

          <h3 class="subsection-title">8. Conservation des données</h3>
          <div class="text-content">
            <p>Sauf si la loi l'exige (par exemple, obligations légales de conservation), nous stockons les données personnelles uniquement aussi longtemps que nécessaire pour servir l'objectif pour lequel elles ont été collectées.</p>
          </div>

          <h3 class="subsection-title">9. Confidentialité des mineurs</h3>
          <div class="text-content">
            <p>Nos services ne sont pas destinés aux mineurs. Nous ne collectons pas sciemment d'informations personnelles auprès de personnes de moins de 18 ans.</p>
          </div>
        </div>
      </section>

      <!-- Conditions d'utilisation -->
      <section class="card terms-card">
        <div class="card-content">
          <h2 class="section-title">Conditions d'utilisation</h2>
          
          <h3 class="subsection-title">1. Description du service</h3>
          <div class="text-content">
            <p>
              Nous fournissons une gamme de services B2B et de SaaS conçus pour digitaliser, renforcer la présence en ligne, 
              améliorer l'efficacité et la productivité des entreprises.
            </p>              
          </div>

          <h3 class="subsection-title">2. Utilisation acceptable</h3>
          <div class="text-content">
            <p>
              En utilisant notre service, vous acceptez de respecter les règles suivantes :
            </p>
            <ul class="feature-list">
              <li><strong>Légalité :</strong> Ne pas utiliser notre service à des fins illégales ou non autorisées.</li>
              <li><strong>Respect des ressources :</strong> Ne pas abuser des ressources ou perturber le service.</li>
            </ul>
          </div>

          <h3 class="subsection-title">3. Propriété intellectuelle</h3>
          <div class="text-content">
            <p>
              Tout le contenu et les matériaux disponibles sur notre service sont protégés par des droits de propriété 
              intellectuelle et sont la propriété exclusive de notre entreprise.
            </p>
          </div>

          <h3 class="subsection-title">4. Limitation de responsabilité</h3>
          <div class="text-content">
            <p>Le service et toutes les informations qui y sont fournies sont fournis « tels quels » et « tels que disponibles » sans aucune garantie. DANS LA MESURE PERMISE PAR LA LOI, NOUS DÉCLINONS EXPRESSÉMENT TOUTE GARANTIE DE QUELQUE NATURE QUE CE SOIT, EXPRESSE OU IMPLICITE, Y COMPRIS LES GARANTIES IMPLICITES DE QUALITÉ MARCHANDE, D'ADÉQUATION À UN USAGE PARTICULIER ET DE NON-CONTREFAÇON. DANS LA MESURE PERMISE PAR LA LOI, NOUS NE SERONS PAS RESPONSABLES DE TOUT DOMMAGE INDIRECT, ACCESSOIRE, SPÉCIAL, CONSÉCUTIF, EXEMPLAIRE OU PUNITIF, NI DE LA PERTE DE PROFITS OU DE REVENUS. NOTRE RESPONSABILITÉ TOTALE POUR TOUTE RÉCLAMATION EN VERTU DE CES CONDITIONS EST LIMITÉE AU MONTANT QUE VOUS NOUS AVEZ PAYÉ POUR UTILISER LE SERVICE DANS LES 12 MOIS PRÉCÉDANT LA RÉCLAMATION.</p>
          </div>

          <h3 class="subsection-title">5. Résiliation</h3>
          <div class="text-content">
            <p>
              Nous nous réservons le droit de suspendre ou de résilier votre accès au service en cas de violation 
              de ces conditions.
            </p>
          </div>

          <h3 class="subsection-title">6. Paiements</h3>
          <div class="text-content">
            <p>
              Pour les utilisateurs des forfaits payants, les paiements doivent être effectués selon les conditions 
              spécifiées au moment de l'inscription. Les abonnements à nos SaaS sont :
            </p>
            <ul class="feature-list">
              <li>annuels et payables à chaque date anniversaire annuelle de souscription.</li>
              <li>à vie et payés une seule fois lors de l'inscription.</li>
            </ul>
          </div>

          <h3 class="subsection-title">7. Modifications des conditions</h3>
          <div class="text-content">
            <p>
              Nous pouvons modifier ces conditions à tout moment. Les modifications seront effectives dès leur 
              publication sur cette page.
            </p>
          </div>

          <h3 class="subsection-title">8. Loi applicable</h3>
          <div class="text-content">
            <p>
              Ces conditions seront régies et interprétées conformément aux lois en vigueur dans notre juridiction.
            </p>
          </div>

          <h3 class="subsection-title">9. Frais et taxes</h3>
          <div class="text-content">
            <p>Les utilisateurs des services payants se verront facturer les frais indiqués dans le plan d'abonnement concerné. Tous les frais sont hors taxes, que nous facturerons selon le cas. Vous acceptez de payer toutes les taxes applicables, autres que les taxes basées sur nos revenus bruts ou notre revenu net.</p>
          </div>

          <h3 class="subsection-title">10. Politique de remboursement</h3>
          <div class="text-content">
            <p>Sauf si la loi l'exige, nous ne sommes pas obligés de vous fournir un remboursement à tout moment ou pour quelque raison que ce soit.</p>
          </div>

          <h3 class="subsection-title">11. Annulation du service par nous</h3>
          <div class="text-content">
            <p>En plus de ce qui précède, nous nous réservons le droit d'annuler unilatéralement le service si vous ne respectez pas ces conditions, si nous détectons des schémas d'utilisation inhabituels ou des utilisations non autorisées, ou en réponse aux demandes des forces de l'ordre ou d'autres organismes publics.</p>
          </div>

          <h3 class="subsection-title">12. Modifications du service</h3>
          <div class="text-content">
            <p>Nous modifions et améliorons constamment notre service. Nous pouvons ajouter ou supprimer des fonctionnalités, suspendre ou arrêter complètement le service. Nous nous réservons le droit de modifier tout plan d'abonnement et/ou d'ajuster le prix du service à notre seule et absolue discrétion.</p>
          </div>

          <h3 class="subsection-title">13. Indemnisation</h3>
          <div class="text-content">
            <p>Vous nous indemniserez et nous tiendrez indemnes, ainsi que nos administrateurs, dirigeants, employés et agents respectifs, contre toutes les réclamations, demandes, actions, jugements, obligations, responsabilités, coûts, dépenses, dommages et pertes encourus à la suite (a) de votre violation de l'une de ces conditions ; (b) de toute violation ou violation présumée de tout droit de propriété intellectuelle découlant de vos actions ou omissions ; et/ou (c) de votre violation de toute loi applicable.</p>
          </div>

          <h3 class="subsection-title">14. Conformité réglementaire</h3>
          <div class="text-content">
            <p>Vous déclarez et garantissez que vous êtes à tout moment en conformité avec toutes les lois applicables (y compris toutes les sanctions applicables et les réglementations de contrôle des exportations) concernant toutes les activités menées ici ainsi que votre utilisation du Service.</p>
          </div>
        </div>
      </section>



      <!-- Call to action -->
      <div class="cta-container">
        <router-link to="/contact" class="cta-button">Nous contacter pour plus d'informations</router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { useHead } from '@vueuse/head'

export default {
  name: 'MentionsLegalesPage',
  setup() {
    useHead({
      title: 'Arynae - Politique de confidentialité et conditions d\'utilisation',
      meta: [
        { name: 'description', content: 'Politique de confidentialité et conditions d\'utilisation d\'Arynae. Consultez notre politique de protection des données et vos droits concernant nos services B2B et SaaS.' },
        { name: 'keywords', content: 'politique confidentialité, conditions utilisation, RGPD, protection données, droits utilisateurs, SaaS, sécurité données, B2B' },
        { name: 'robots', content: 'index, nofollow' },
        { name: 'author', content: 'Arynae' },
        { 'http-equiv': 'Content-Type', content: 'text/html; charset=utf-8' },
        // Open Graph essentiels
        { property: 'og:type', content: 'website' },
        { property: 'og:title', content: 'Arynae | Politique de confidentialité et conditions d\'utilisation' },
        { property: 'og:description', content: 'Consultez nos conditions d\'utilisation, notre politique de protection des données et vos droits concernant nos services B2B et SaaS.' },
        { property: 'og:url', content: 'https://www.arynae.com/mentions-legales' },
        { property: 'og:locale', content: 'fr_FR' },
        { property: 'og:image', content:'https://arynae.com/img/arynae-social-card.png' },
        { property: 'og:image:alt', content:'Agence digitale - Solutions No Code, SaaS, Chatbots & SEO' },
        // Twitter Card basiques
        { name: 'twitter:card', content: 'summary_large_image' },
        { name: 'twitter:title', content: 'Arynae | Politique de confidentialité et conditions d\'utilisation' },
        { name: 'twitter:description', content: 'Consultez nos conditions d\'utilisation, notre politique de protection des données et vos droits concernant nos services B2B et SaaS.' },
        { name: 'twitter:image', content: 'https://arynae.com/img/arynae-social-card.png' },
        { name: 'viewport', content: 'width=device-width, initial-scale=1.0' }
      ],
      link: [
        { rel: 'canonical', href: 'https://www.arynae.com/mentions-legales' },
        { rel: 'alternate', hreflang: 'fr', href: 'https://www.arynae.com/mentions-legales' }
      ],
      htmlAttrs: {
        lang: 'fr'
      }
    })
    
    return {}
  }
}
</script>

<style scoped>
.mentions-legales-page {
  font-family: Arial, sans-serif;
  color: #333;
}

/* Header Styles */
.header {
  background: linear-gradient(to right, #2563EB, #7C3AED);
  padding-bottom: 6rem;
  color: white;
}

.header-content {
  text-align: center;
  padding: 5rem 2rem 3rem;
}

.main-title {
  font-size: 2.75rem;
  margin-bottom: 1rem;
}

.subtitle {
  font-size: 1.25rem;
  max-width: 800px;
  margin: 0 auto;
  font-style: italic;
}

/* Content Container */
.content-container {
  max-width: 1200px;
  margin: -3rem auto 4rem;
  padding: 0 2rem;
}

/* Card Styles */
.card {
  background: linear-gradient(to bottom, #ffffff, #f3f4f6);
  border-radius: 0.5rem;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
  margin-bottom: 2rem;
  overflow: hidden;
}

.card-content {
  padding: 2rem;
}

.section-title {
  font-size: 1.75rem;
  margin-bottom: 1.5rem;
  color: #333;
  position: relative;
}

.section-title:after {
  content: "";
  position: absolute;
  bottom: -8px;
  left: 0;
  width: 60px;
  height: 3px;
  background: linear-gradient(to right, #2563EB, #7C3AED);
}

.subsection-title {
  font-size: 1.35rem;
  margin: 2rem 0 1rem;
  color: #444;
}

.text-content {
  font-size: 1rem;
  line-height: 1.6;
  color: #555;
}

.text-content p {
  margin-bottom: 1rem;
}

.contact-logo {
  display: flex;
  justify-content: center;
  margin: 2rem 0;
}

.logo-img {
  height: 96px;
}

.contact-email {
  margin-top: 1rem;
}

.phone-img {
  vertical-align: middle;
}

.link {
  color: #3B82F6;
  text-decoration: none;
  transition: color 0.3s;
}

.link:hover {
  color: #2563EB;
  text-decoration: underline;
}

/* Feature Lists */
.feature-list {
  list-style: none;
  padding-left: 0;
  margin: 1.5rem 0;
}

.feature-list li {
  position: relative;
  padding-left: 1.75rem;
  margin-bottom: 1rem;
}

.feature-list li:before {
  content: "✓";
  position: absolute;
  left: 0;
  color: #2563EB;
  font-weight: bold;
}

/* Call to Action */
.cta-container {
  text-align: center;
  margin: 3rem 0;
}

.cta-button {
  background: linear-gradient(to right, #2563EB, #7C3AED);
  color: white;
  font-size: 1.25rem;
  font-weight: bold;
  padding: 1rem 2.5rem;
  border: none;
  border-radius: 2rem;
  cursor: pointer;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  display: inline-block;
  text-decoration: none;
}

.cta-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.25);
}

/* Responsive Adjustments */
@media (max-width: 768px) {
  .header-content {
    padding: 4rem 1rem 2rem;
  }
  
  .main-title {
    font-size: 2rem;
  }
  
  .content-container {
    padding: 0 1rem;
  }
  
  .card-content {
    padding: 1.5rem;
  }
  
  .section-title {
    font-size: 1.5rem;
  }
  
  .subsection-title {
    font-size: 1.25rem;
  }
  
  .cta-button {
    font-size: 1.1rem;
    padding: 0.875rem 2rem;
  }
}
</style>